import axios from '../../config/axios';

function customerStatement(params) {
    return axios().get(`/sales/customers/${params.customer_id}/statement`, { params });
}

function paymentDetails(params) {
    return axios().get(`/sales/reports/payment-details`, { params });
}

function customersBalance(params) {
    return axios().get(`/sales/reports/customers-balance`, { params });
}

function unearnedRevenue(params) {
    return axios().get(`/sales/reports/unearned-revenue`, { params })
}

export default {
    customerStatement,
    paymentDetails,
    customersBalance,
    unearnedRevenue
}